import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { OrderProperty } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderPropertyService extends TmsWebBaseEditCreateService<OrderProperty, OrderProperty> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('SalesOrderProperty', $localize`Sales Order Property`);
  }
}
